export default __webpack_public_path__ + "static/sim_logo-b0b9b62130c172a4de355f663f969482.svg";